import React,{useState} from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import a from '../assets/img/pdf/Diagnostics-Journal-publication.pdf'
// import FileViewer from 'react-file-viewer';
import logo1 from "../assets/img/logo.svg";
function Disclaimer (){
    const [overallHealthScoreModal, setOverallHealthScoreModal] = useState(false);
    const navigate = useNavigate();

    return(
        <>
          <Modal size="lg" show={overallHealthScoreModal} onHide={() => setOverallHealthScoreModal(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title><b>Validation Document</b></Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                    
                                    <div style={{ height: '500px'}}>
                                    {/* <FileViewer 
                                      fileType={'pdf'}
                                      filePath={a}
                                    /> */}
                                    <iframe src={a} width="100%" height="500px" ></iframe>
                                    </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="danger" onClick={() => setOverallHealthScoreModal(false)}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
          </Modal>

          <div 
           style={{
            textAlign: 'center',
            padding: '10px',
            fontSize: '50px',
            // lineHeight: '24px',
            color:'red'
          }}>  <div className="logo">
          <img src={logo1} alt="" />
         </div>
         <h2>DISCLAIMER</h2>
          </div>    
          <div 
          style={{
          // textAlign: 'center',
           padding: '50px',
           fontSize: '20px',
           lineHeight: '25px',
           backgroundColor:'#cacece',
           margin:'0px 100px 0px 100px',
           borderRadius:'30px'
           }}>
                1. The test results obtained from POCT devices are subject to a permissible range of variation between 15% and 20%. This range accounts for potential fluctuations in the testing process and is intended to provide a margin of error. 
                  <br /><br/>
                 2. Results of tests may vary from laboratory to laboratory and also in some parameters from time to time for the same patient.
                  <br /><br/>
                 3. Users are advised to consider this variability when interpreting and relying on the test results. The provided range is established to ensure a reasonable degree of accuracy in the assessment of POCT devices, acknowledging the inherent uncertainties in testing methodologies. Any decisions or actions based on these results should take into account the specified range of variation. 
                  <br /><br/>
                 4. Patients are encouraged to confirm any information obtained from this dashboard with other sources and review all information regarding any medical condition or the treatment of such condition with a physician.
                  <br /><br/>
                 5. The organization or individuals conducting the tests are not liable for any consequences arising from the natural variability within the stated range.
                  <br /><br/>
                 6. Healthnovo will not be held responsible for any medico-legal actions and or have no responsibility for misinterpretation of the dashboard.
                  <br/>
                  <div style={{display:'flex',
                  alignItems:'flex-end',
                  justifyContent:'space-between',
                  marginTop:'30px'


                      }}>
                    <Button onClick={()=>setOverallHealthScoreModal(true)}>Validation Document</Button>
                    <Button variant="success" onClick={()=>navigate("/dashboard")}>Proceed</Button>
                </div>

          </div> 
        </>    
    )
}

export default Disclaimer;